import { render, staticRenderFns } from "./PatientRegister.vue?vue&type=template&id=1aa0bdcc&"
import script from "./PatientRegister.vue?vue&type=script&lang=js&"
export * from "./PatientRegister.vue?vue&type=script&lang=js&"
import style0 from "./PatientRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports